import axiosInstance from "@/services/axiosInstance";
import { API_V2 } from "@Models/GWDomain";

export type WhatsappMessageStatus =
  | "pendiente"
  | "enviado"
  | "entregado"
  | "leido"
  | "fallido"
  | "omitido";

export interface IWhatsappMessageLog {
  id: number;
  type: "confirmacion" | "recordatorio" | "comprobante" | string;
  trigger: "auto" | "manual" | string;
  to: string | null;
  status: WhatsappMessageStatus | string;
  reason: string | null;
  provider?: string | null;
  sentAt: string | null;
  statusAt: string | null;
  employeeName: string | null;
}

/** GET /whatsapp/messages?saleDocumentId=|reservationId= (nunca lanza: devuelve []). */
export const getWhatsappMessages_service = async (params: {
  saleDocumentId?: number;
  reservationId?: number;
}): Promise<IWhatsappMessageLog[]> => {
  try {
    const response = await axiosInstance.get(`${API_V2}/whatsapp/messages`, {
      params,
    });
    const data = response?.data?.data;
    return Array.isArray(data) ? data : [];
  } catch {
    return [];
  }
};
